// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fb6a0d1c","453":"71c0085b","455":"4427eab9","977":"457b215d"}[chunkId] + ".chunk.js";
};